export class SignedRequest {
  signed_request: string;
  url: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/model/signedRequest.ts